class Calculator {
  calcCartPrice(items) {
    var res = 0;
    items.map(item => {
      res += this.calcItemPrice(item);
    });
    return res;
  }

  calcItemPrice(item) {
    var res = item.price * item.quantity;
    if (item.modifiers) {
      res += this.modifierPrice(item.modifiers) * item.quantity;
    }
    return res || 0;
  }

  modifierPrice(modifiers) {
    let sum = 0;
    var that = this;
    modifiers.forEach(function(md) {
      sum += that.submodifierPrice(md) * (md.quantity || 1);
    });
    return sum;
  }
  submodifierPrice(modifier) {
    var sum = modifier.Price;
    if (modifier.selectedSubmodifiers) {
      modifier.selectedSubmodifiers.forEach(element => {
        for(var i=0; i < element.quantity;i++)
        {
          sum += element.Price;
        }
      });
    }
    return sum;
  }
}
export const calculator = new Calculator();
